// import { useDispatch } from 'react-redux';
import { Filter } from 'tabler-icons-react';
import { useModal } from 'Hooks';
// import { setSelectedMarker } from 'Actions';
import { SearchBox, Button, ModalBoxFilter } from 'Elements';
import styles from 'partials/map-search-box.module.scss';

export const MapSearchBox = () => {
	const [openFilter, toggleFilter] = useModal();
	// const dispatch = useDispatch();

	// const handleSubmit = (val) => {
	// 	dispatch(setSelectedMarker(val));
	// };

	return (
		<div className={styles.searchbox}>
			<SearchBox className={styles.search} />
			<Button onClick={toggleFilter} className={styles.filterBtn}>
				<Filter size={25} color="#fff" />
			</Button>
			<ModalBoxFilter
				isOpen={openFilter}
				onClose={toggleFilter}
				size="sm"
			/>
		</div>
	);
};
